<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'Copilot Demo'}}</ion-title>
        <ion-buttons slot="end">
            <ion-button size="large" fill="clear" (click)="dismiss('cancel', null)">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="!copilotData || !copilotData.suggestion">
    Fetching suggested responses. Please wait, this can be very slow...
</ion-content>

<ion-content [scrollEvents]="true" *ngIf="copilotData.suggestion">
    <ion-list>

        <!-- Suggested Response -->
        <ion-item-divider>
            <ion-label>{{'Suggested Response'}}</ion-label>
        </ion-item-divider>
        <ion-item>
            <p><small class="copilotContent">{{copilotData.suggestion}}</small>
            </p>
            <div slot="end">
                <ion-button (click)="dismiss('response', null)" shape="round" size="medium">
                    Use
                </ion-button>
            </div>
        </ion-item>

        <!-- Recommended Resources -->
        <ion-item-divider>
            <ion-label>{{'Recommended Resources'}}</ion-label>
        </ion-item-divider>

        <ion-item button *ngFor="let t of copilotData.references; let i=index" (click)="showResource(i)">
            <div>
                <span style="font-weight: bold; font-size: small;">{{t.reference_type}} - {{t.title}}</span>
                <div *ngIf="i==clickedIndex ">
                    <br />
                    <small class="copilotContent">{{t.content}}</small>
                </div>
            </div>
            <div slot="end">
                <ion-button (click)="dismiss('resource', i)" shape="round" size="small" style="margin-right: 5px;">
                    Use
                </ion-button>
            </div>
        </ion-item>
    </ion-list>
</ion-content>
